// extracted by mini-css-extract-plugin
export default {"container":"eQ-z","title":"fQ-z","link":"gQ-z"};